module.exports = __webpack_public_path__ + "static/media/dashboard-logo.876b7493.png";